// extracted by mini-css-extract-plugin
module.exports = {"container":"Design_container__3ItG3","preview":"Design_preview__32QJ-","bottom":"Design_bottom__3xWWP","icon":"Design_icon__17JJE","addDiv":"Design_addDiv__2C2u1"};